import { render, staticRenderFns } from "./CustomSales.vue?vue&type=template&id=502b2c95&"
import script from "./CustomSales.vue?vue&type=script&lang=js&"
export * from "./CustomSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports